<template>
  <div class="desc_cell" v-if="show">
    <div class="text_head">注:</div>
    <div>
      <slot name="desc"></slot>
      <span>{{content}}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ["show", "content"]
};
</script>

<style lang="less">
.desc_cell {
  display: flex;
  font-size: 14px;
  padding: 10px 15px;
  background-color: #fff;
}

.text_head {
  font-size: 14px;
  color: red;
}
</style>
